import { render } from "./PageListarRefeicao.vue?vue&type=template&id=20871c2a"
import script from "./PageListarRefeicao.vue?vue&type=script&lang=js"
export * from "./PageListarRefeicao.vue?vue&type=script&lang=js"

import "./PageListarRefeicao.vue?vue&type=style&index=0&id=20871c2a&lang=css"
/* custom blocks */
import block0 from "./PageListarRefeicao.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__